"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UiConfigSchema = exports.TaskSchema = void 0;
const zod_1 = require("zod");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
exports.TaskSchema = zod_1.z.discriminatedUnion('mode', [
    tape_sanitizer_1.PyXlsx2Csv2ConvertRangeSchema.extend({
        srcArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Source (input) artifact slug for this operation'),
    }),
    tape_sanitizer_1.PyXlsx2Csv2ExtractValuesSchema.extend({
        srcArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Source (input) artifact slug for this operation'),
    }),
]);
exports.UiConfigSchema = zod_1.z.discriminatedUnion('mode', [
    tape_sanitizer_1.PyXlsx2Csv2ConvertRangeSchema,
    tape_sanitizer_1.PyXlsx2Csv2ExtractValuesSchema,
]);
exports.nodeType = 'operation_pyXlsx2csv2';
//# sourceMappingURL=types.js.map